import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import { messages } from "./locales/index.js";
import { appSupport } from "@thegetty-private/rad-app-utils";
import * as allSettled from "promise.allsettled";
import "whatwg-fetch";
import { GettyUICore, GettyUIForms } from "@thegetty-private/getty-ui";
import { createHead } from "@unhead/vue";
import fromEntries from "object.fromentries";
import { i18n } from "@/i18n";

if (!Object.fromEntries) {
  fromEntries.shim();
}

let app = createApp(App);

app.use(router);

const head = createHead();
app.use(head);

if (!Promise.allSettled && allSettled) {
  allSettled.shim();
}

app.use(GettyUICore, {
  i18nConfig: { locale: "en", fallbackLocale: "en", messages: messages }
});

app.use(GettyUIForms);

const pinia = createPinia();
pinia.use(({ store }) => {
  store.i18n = i18n;
});
app.use(pinia);

appSupport.setupSentry(
  app,
  "collection-online-retrofit",
  process.env.VUE_APP_COMMIT_HASH
);

// before each route check if the user is navigating within a route (e.g. "gallery/123" -> "gallery/456")
// if they are, trigger the beforeEnter function of the route, because otherwise it won't be called  (DEV-8834)

router.beforeEach((to, from, next) => {
  if (to.name == from.name) {
    let route = to.matched.find((route) => route.name == to.name);
    if (route && route.beforeEnter) {
      route.beforeEnter(to, from, next);
    }
  } else {
    next();
  }
});

// setup google analytics
appSupport.setupGoogleAnalytics(app, undefined, true);

app.mount("#app");
